import Vue from "vue";
import Router from "vue-router";
import DefaultView from  "@/views/Questionnaire";

Vue.use(Router);

export default new Router({

  routes: [
      {
          path: "/(index.html)?",
          name: "home",
          get component() {
              if (true) {
                  return DefaultView;
              } else {
                  return DefaultView;
              }
          }
      },
  ]
});



/*

export default new Router({
    routes: [{
           path: "/(index.html)?",
            component: () =>
                import ("@/views/Questionnaire")
        }
    ]
});
*/
